import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import {
    BatchResponse,
    OrderQuoteSummaryResponse,
    PackOrderResponse,
    batchResponseInterface,
    orderInterface,
    orderQuoteSummaryInterface,
    packOrderInterface,
    toBatchResponse,
    toOrderQuoteSummary,
    toPackOrder,
} from '../orders';

export default (axios: AxiosInstance = baseAxios): { assignPacks: (orders: orderInterface[]) => Promise<void>; unassignPacks: (orders: orderInterface[]) => Promise<void>; assignPackFromTote: (toteCode: string) => Promise<void>; generatePackingSlip: (orderId: number) => Promise<string>; selectOrderService: (orderId: number, objectId: string) => Promise<orderQuoteSummaryInterface>; getShippingQuotes: (orderId: number, refresh?: boolean) => Promise<orderQuoteSummaryInterface | null>; updatePackOrders: (orders: packOrderInterface[]) => Promise<packOrderInterface[]>; purchaseLabels: (orders: orderInterface[], printPackingSlips: boolean) => Promise<string>; purchaseLabelsBatchData: (batchId: string) => Promise<batchResponseInterface>; assignPacksByUser: (ordersToPackQuantity: number) => Promise<void>; assignPacksByPriority: (ordersToPackQuantity: number) => Promise<void>; assignPacksByQuantity: (ordersToPackQuantity: number) => Promise<void>; } => ({
    assignPacks: async (orders: orderInterface[]): Promise<void> => {
        return await axios.post('/api/orders/assignPacksBySelected', { orders });
    },

    unassignPacks: async (orders: orderInterface[]): Promise<void> => {
        return await axios.post('/api/orders/unassignPacks', { orders });
    },

    assignPackFromTote: async (toteCode: string): Promise<void> => {
        await axios.post('/api/orders/assignPackFromTote', { tote_code: toteCode });
    },

    generatePackingSlip: async (orderId: number): Promise<string> => {
        const response = await axios.get<{ url: string }>(`/api/orders/${orderId}/packingSlip`);

        return response.data.url;
    },

    selectOrderService: async (orderId: number, objectId: string): Promise<orderQuoteSummaryInterface> => {
        const response = await axios.post<{ quotes: OrderQuoteSummaryResponse }>(`/api/orders/${orderId}/selectService`, { object_id: objectId });

        return toOrderQuoteSummary(response.data.quotes);
    },

    getShippingQuotes: async (orderId: number, refresh: boolean = false): Promise<orderQuoteSummaryInterface | null> => {
        let url = `/api/orders/${orderId}/getQuote`;
        if (refresh) {
            url += '?refresh=true';
        }
        const response = await axios.get<{ quotes: OrderQuoteSummaryResponse | null }>(url);

        return toOrderQuoteSummary(response.data.quotes);
    },

    updatePackOrders: async (orders: packOrderInterface[]): Promise<packOrderInterface[]> => {
        const response = await axios.post<{ orders: PackOrderResponse[] }>('/api/orders/batch/index', { orders });

        return response.data.orders.map(toPackOrder);
    },

    purchaseLabels: async (orders: orderInterface[], printPackingSlips: boolean): Promise<string> => {
        const response = await axios.post<{ batch_id: string }>('/api/orders/purchaseLabels', { orders, print_packing_slips: printPackingSlips });

        return response.data.batch_id;
    },

    purchaseLabelsBatchData: async (batchId: string): Promise<batchResponseInterface> => {
        const response = await axios.get<BatchResponse>(`/api/jobBatch/${batchId}`);

        return toBatchResponse(response.data);
    },

    assignPacksByUser: async (ordersToPackQuantity: number): Promise<void> => {
        return await axios.post('/api/orders/assignPacksByUser', {
            orders_to_pack_quantity: ordersToPackQuantity,
        });
    },

    assignPacksByPriority: async (ordersToPackQuantity: number): Promise<void> => {
        return await axios.post('/api/orders/assignPacksByPriority', {
            orders_to_pack_quantity: ordersToPackQuantity,
        });
    },

    assignPacksByQuantity: async (ordersToPackQuantity: number): Promise<void> => {
        return await axios.post('/api/orders/assignPacksByQuantity', {
            orders_to_pack_quantity: ordersToPackQuantity,
        });
    },
});
